// extracted by mini-css-extract-plugin
export default {"radio__checkmark":"oXNM2T","radio__label":"y8V9y5"};